// extracted by mini-css-extract-plugin
export var button = "AddCardFormSkeleton-module--button--df6f7";
export var fieldGroup = "AddCardFormSkeleton-module--fieldGroup--d56a6";
export var input = "AddCardFormSkeleton-module--input--9b2c6";
export var label = "AddCardFormSkeleton-module--label--23f53";
export var wrapper = "AddCardFormSkeleton-module--wrapper--50596";